import { FC, useEffect, useState } from 'react'
import { Button, Input, message, Table, Image, Upload, DatePicker } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { useSupplierOfferModel } from './supplierOfferModel'
import { useOfferDetailModel } from '@/views/inquires/offer/view/details/offerDetailModel'
import { useDictModel } from '@/views/base/dict/dictModel'
import { globalPrompt } from '@/components/message'
import { getBaseRequestUrl, getToken } from '@/utils/constants'
import { publicService } from '@/views/public/publicService'
import { convertRes2Blob } from '@/utils/exportFile'
import { importPropsConfig } from '@/utils/importFile'
import { useDtpDetailModel } from '../dtpDetailModel'
import { enquiryService } from '../../../dtpService'
import { useExtractModel } from './extractModel'
import { EditableCell, EditableRow } from '@/components/YHEditTable/editTable'
import { YhBut } from '@/components/YhButton'
import { YhAuth } from '@/components/auth/YhAuth'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { momentFormat } from '@/utils/utils'
import moment from 'moment'

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    // const {
    //     dataSource, selectedRowKeys, pgCfg,
    //     loadData, setSelectedRowKeys, setSupplierDialog, dispbleOffer, transferOffer,
    // } = useSupplierOfferModel();
    const { selectedRowKeys, setSelectedRowKeys, fileList, setFileList, removeFile, upLoadCallback, billLadingUpdate } = useExtractModel()
    const { getTreeNodeName } = useDictModel(() => [])
    const { editFormVal } = useDtpDetailModel(() => [])

    const getFileList = async () => {
        let params = {
            page: {
                pageSize: 1000,
                pageNum: 1,
            },
            code: editFormVal.code,
        }
        let { retData } = await enquiryService.billLadingPage(params)
        const { records, ...pg } = retData
        console.log(records)
        setFileList(
            (records ?? []).map((item) => ({
                ...item,
                key: item.id,
                checkTime: item.checkTime ? moment(item.checkTime) : null,
                approveTime: item.approveTime ? moment(item.approveTime) : null,
            }))
        )
    }
    useEffect(() => {
        getFileList()
    }, [])
    //下载文件
    const downloadFile = async (fileId: string, fileName: string) => {
        if (!fileId) return message.warning('文件异常，无法下载查看')
        //pdf开网页预览
        if (fileId.indexOf('.pdf') >= 0) {
            window.open(`${getBaseRequestUrl()}/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
            return
        }
        try {
            let result = await publicService.downloadFile(fileId)
            convertRes2Blob(result, fileName)
        } catch (error) {
            console.error(error)
        }
    }
    const columns = [
        {
            title: '序号',
            width: 40,
            align: 'center',
            fixed: 'left',
            render: (t: any, r: any, i: any) => i + 1,
        },
        {
            title: '提单编号',
            width: 180,
            dataIndex: 'billCode',
            editable: true,
        },
        {
            title: '附件名称',
            width: 160,
            dataIndex: 'name',
            render: (text: any, record: any) => {
                if (text && (text.indexOf('.png') > -1 || text.indexOf('.jpg') > -1 || text.indexOf('.gif') > -1 || text.indexOf('.jpeg') > -1)) {
                    return (
                        <>
                            <Image
                                src={`${getBaseRequestUrl()}/fsrv/fetch/${record.md5}?Authorization=${getToken()}`}
                                style={{ width: '40px', height: '40px', marginRight: '10px' }}
                            />
                            <span style={{ color: 'blue' }} onClick={() => downloadFile(record.md5, record.name)}>
                                {text}
                            </span>
                        </>
                    )
                } else {
                    return (
                        <span style={{ color: 'blue' }} onClick={() => downloadFile(record.md5, record.name)}>
                            {text}
                        </span>
                    )
                }
            },
        },
        // {
        //     title: '上传时间',
        //     width: 160,
        //     dataIndex: 'createTime',
        //     render: (text: string) => momentFormat(text)
        // },
        {
            title: '创建人',
            width: 160,
            dataIndex: 'createUser',
        },
        {
            title: '审核说明',
            width: 160,
            dataIndex: 'checkExplain',
        },
        {
            title: '审核日期',
            width: 160,
            dataIndex: 'checkTime',
            editable: true,
            editType: 'datepicker',
            render: (v: any) => momentFormat(v as string, 'YYYY-MM-DD'),
        },
        {
            title: '审核人',
            width: 160,
            dataIndex: 'checkUser',
        },
        {
            title: '审批说明',
            width: 160,
            dataIndex: 'approveExplain',
        },
        {
            title: '审批日期',
            width: 160,
            dataIndex: 'approveTime',
            editable: true,
            editType: 'datepicker',
            render: (v: any) => momentFormat(v as string, 'YYYY-MM-DD'),
        },
        {
            title: '审批人',
            width: 160,
            dataIndex: 'approveUser',
        },
        {
            title: '状态',
            width: 160,
            dataIndex: 'status',
        },
        {
            title: '操作',
            width: 80,
            fixed: 'right',
            align: 'center',
            render: (text: any, record: any) => (
                <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_TDSAVE}>
                    <Button
                        className="tab-item tab-active"
                        type="link"
                        shape="round"
                        onClick={(e) => {
                            billLadingUpdate(record)
                            e.stopPropagation()
                        }}
                    >
                        保存
                    </Button>
                </YhAuth>
            ),
        },
    ]
    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === 'totalAmount' ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        console.log(row)
        const index = fileList.findIndex((item) => row.key === item.key)
        const item = fileList[index]
        fileList.splice(index, 1, { ...item, ...row })
        console.log(fileList)
        setFileList([...fileList])
    }
    const action = (
        <>
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`00`, upLoadCallback)}>
                <Button className="mr-5" type="link" shape="round">
                    导入
                </Button>
            </Upload>
            <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_TDDEL}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => {
                        if (selectedRowKeys.length !== 1) {
                            message.warning('请选择单挑进行删除')
                            return
                        }
                        if (editFormVal.status === 'transport-status.effect') {
                            message.warning('此状态下不可删除')
                            return
                        }
                        removeFile(selectedRowKeys[0])
                    }}
                >
                    删除
                </Button>
            </YhAuth>
        </>
    )

    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code)
        let newSelectedRowKeys = [...selectedRowKeys]
        if (findIndex === -1) {
            newSelectedRowKeys.push(code)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            newSelectedRowKeys.splice(findIndex, 1)
            setSelectedRowKeys(newSelectedRowKeys)
        }
    }

    return (
        <YhBox title="提单列表" style={{ marginBottom: '75px' }} rightChildren={action}>
            <Table
                rowKey={(record) => record.key}
                rowSelection={{
                    //全部选中时  (存string[])
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        let changeRowId = changeRows.map((item) => item.key)
                        selected
                            ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                            : setSelectedRowKeys((origin) => origin.filter((item) => changeRowId.indexOf(item) < 0))
                    },
                    onSelect: (record) => onRow(record.key),
                    selectedRowKeys: selectedRowKeys,
                }}
                // columns={columns}
                columns={newColumn as ColumnsType<any>}
                dataSource={fileList}
                pagination={false}
                onRow={(record) => ({
                    onClick: () => onRow(record.key),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record.key])
                    },
                })}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 360px)' }}
            />
        </YhBox>
    )
}
